import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface IdentityVerificationData{
    first_name?: string;
    last_name?:string;
    email?: string;
    contact?: string;
    linkedin_url?: string;
    website_url?: string;
    address_proof_attachment?: string;
    passport_attachment?: string;
    country_code?: string;
}

interface IdentityVerificationFormData {
    complete: boolean;
    data: IdentityVerificationData | null;
}

interface IdentityVerificationState {
    identityVerificationData: IdentityVerificationFormData[]
}

const initialState: IdentityVerificationState = {
    identityVerificationData: []
}

const identityVerificationSlice = createSlice({
    name: "identityVerification",
    initialState,
    reducers: {
        addIdentityVerificationForm: (state) => {
            state.identityVerificationData.push({complete: false, data: null})
        },
        saveIdentityVerificationForm: (state, action) => {
            const index = action.payload.index;
            const data = action.payload.data;
            state.identityVerificationData[index] = {complete: true, data: data}
        },
        updateIdentityVerificationForm: (state, action) => {
            const index = action.payload;
            if (state.identityVerificationData[index]){
                state.identityVerificationData[index].complete = false
            }
        }
    }
})

export const {
    addIdentityVerificationForm,
    saveIdentityVerificationForm,
    updateIdentityVerificationForm,
} = identityVerificationSlice.actions

export default identityVerificationSlice.reducer;